import React, { useState } from 'react'
import classnames from 'classnames'
import { Duration } from 'luxon'
import { FormattedMessage } from 'react-intl'

import { TtIcon } from '@23/ui-react'

import { useLiveDataQuery } from '../../../../../../global/blocs/useLiveData'
import { useAppSelector } from '../../../../../../redux-types'
import { useInterval } from '../../../../../../sharedLegacy/hooks'

import './FocusTimer.scss'

const FocusTimer = () => {
  const { data: liveData } = useLiveDataQuery()
  const [remainingTime, setRemainingTime] = useState(
    +(liveData?.duration_minutes ?? 0) * 60 * 1000
  )
  const liveStartTime = useAppSelector(
    (state) => state.webinar.webinarInfo.broadcasting_start_time
  )

  useInterval(() => {
    setRemainingTime(
      liveStartTime
        ? +(liveData?.duration_minutes ?? 0) * 60 * 1000 -
            (Date.now() - +liveStartTime * 1000)
        : +(liveData?.duration_minutes ?? 0) * 60 * 1000
    )
  }, 1000)

  return (
    <div
      className={classnames('focus-widget focus-timer', {
        'focus-timer-ending': remainingTime < 5 * 60e3,
      })}
    >
      <TtIcon library="one" name="calendar-time" />
      <div className="focus-timer-time">
        {remainingTime > 0 ? (
          <span>
            {Duration.fromMillis(remainingTime + Number.EPSILON).toFormat(
              'mm:ss'
            )}
          </span>
        ) : (
          <span>{Duration.fromMillis(-remainingTime).toFormat('mm:ss')}</span>
        )}
        {remainingTime < 0 && (
          <div className="focus-timer-overtime">
            <FormattedMessage defaultMessage="overtime" />
          </div>
        )}
      </div>
    </div>
  )
}
export { FocusTimer }
